import type { FieldValues, UseFormSetError } from "react-hook-form"
import type { BaseQueryError } from "@/base"
import { parseError } from "@/base"

type Props<Values extends FieldValues> = {
  setError: UseFormSetError<Values>
}

/**
 * @return true if the error was handled
 */
export const handleError =
  <Values extends FieldValues>({ setError }: Props<Values>) =>
  (error: BaseQueryError) => {
    const violations = parseError<Values>(error)
    if (!violations) {
      return false
    }

    violations.forEach(({ propertyPath, title }) => {
      setError(propertyPath || "root.formError", { message: title })
    })

    return true
  }
